<div class="container">
  <div class="row justify-flex-end">
    <div class="col-md-1">
      @if (!panelExpanded) {
        <button mat-flat-button (click)="togglePanel()" style="background-color: transparent" matTooltip="Open Sharepoint Panel">
          <i class="material-icons-outlined" style="color: gray; opacity: 60%">cloud_upload</i>
          @if (!isSmallerScreen) {
            <i class="material-icons" style="color: gray; opacity: 60%; font-size: 18px; margin-right: 5px;">arrow_back</i>
          }
          @if (isSmallerScreen) {
            <i class="material-icons" style="color: gray; opacity: 60%; font-size: 18px; margin-right: 5px;">arrow_upward</i>
          }
        </button>
      }
    </div>
  </div>
  <div class="row button-group" style="justify-content: center">
    <div class="col-md-2" style="width: 200px">
      <mat-button-toggle-group [(ngModel)]="equityService.viewType" (ngModelChange)="onChangeInstallmentView($event)">
        <mat-button-toggle [value]="InstallmentViewType.SYNDICATED">SYNDICATED</mat-button-toggle>
        <mat-button-toggle [value]="InstallmentViewType.CERTIFICATED">CERTIFICATED</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <div class="row info-row align-top">
    <div class="col-md-11">
      <h2>{{projectDetails.name}}</h2>
      <div class="total-header">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-2">
              <div class="total-header-label">Total Equity</div>
            </div>
            <div class="col-md-2">
              <div class="total-header-label">Total Funded</div>
            </div>
            <div class="col-md-2">
              <div class="total-header-label">Total Adjusters</div>
            </div>
            <div class="col-md-2">
              <div class="total-header-label">Remaining Equity</div>
            </div>
          </div>
          <mat-divider class="material-divider"></mat-divider>
        </div>
      </div>
      <div class="total-value">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-2 total-value-label">
              {{projectDetails.total_equity | currency: 'USD': 'symbol': '1.2-2'}}
            </div>
            <div class="col-md-2 total-value-label">
              {{projectDetails.total_funded | currency: 'USD': 'symbol': '1.2-2'}}
            </div>
            <div class="col-md-2 total-value-label">
              {{projectDetails.total_adjusters | currency: 'USD': 'symbol': '1.2-2'}}
            </div>
            <div class="col-md-2 total-value-label">
              {{projectDetails.remaining | currency: 'USD': 'symbol': '1.2-2'}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="row space-between installments-header-row">
        <span class="installments-header">Installments @if (permissions?.installmentPermissions?._create) {
          <button mat-mini-fab class="add-installment-btn" (click)="openAddInstallmentModal()"><i class="material-icons">add</i></button>
        }</span>
        @if (canEditAnything) {
          <button mat-mini-fab class="save-all" matTooltip="Save All" (click)="saveAll()"><mat-icon style="font-size: 18px">save</mat-icon></button>
        }
      </div>
      @if (installments.length==0 && !isLoading) {
        <div class="row no-installments-row">No Current Installments</div>
      }
      @if (installments.length>0 && !isLoading) {
        @for (installment of installments; track installment) {
          <div>
            <equity-installment-installment-entry [installment]="installment" [expanded]="isInstallmentOpen(installment.id)" (expandPanel)="onInstallmentOpen($event)" (closePanel)="onInstallmentClose($event)"></equity-installment-installment-entry>
          </div>
        }
      }
    </div>
  </div>
</div>
